export default __webpack_public_path__ + "static/media/0f7f53baa90e9568.dd70ed7e8e920e738100521fd549dcb2.svg";